export default function(can) {
  // RepairContentHistory
  can('view', 'RepairContentHistory');

  // Message
  can('view', 'Message');

  // Contract
  can('view-info', 'Contract');
  can('moving-checklist', 'Contract');
  can('confirm-follow', 'Contract');
  can('move-out', 'Contract');

  // Receipt
  can('confirm', 'Receipt');

  can('view', 'introduction');
  can('view', 'Home');
}